import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import '@autone/tailwind-config/global.css';

import App from './App';
import store from './old/redux/store';

Sentry.init({
  dsn: 'https://bce6d658a536425d1dd14af3345e6b86@o1115656.ingest.us.sentry.io/4507774801215488',
  integrations: [Sentry.browserTracingIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  environment:
    import.meta.env.MODE === 'development'
      ? 'localhost'
      : import.meta.env.VITE_BUILD_STAGE,
});

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
